import React, {useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import styles from './Reports.module.css';


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));




const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: '16px'
}
}));


const Reports = () => {
    

  const classes = useStyles1();
  const theme = useTheme();


  const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}


  return (
    <div className={styles.pageLayout}>
    <Container style={{width: '55%'}}>
    
        <TableContainer component={Paper} elevation={0}>
      <Table className={classes.table} aria-label="custom pagination table">

      <TableHead>
          <TableRow>
            <TableCell style={{...headerStyle, width: '10px'}}>Reports</TableCell>           
           
          </TableRow>
        </TableHead>

        <TableBody>
         <TableRow>
           <TableCell style={{...tableStyle}}><a href='/salesReport'>Sales Report</a></TableCell>
           </TableRow>
           <TableRow>
           <TableCell style={{...tableStyle}}><a href='/inventoryReport'>Inventory Report</a></TableCell>
           </TableRow>
           <TableRow>
           <TableCell style={{...tableStyle}}><a href='/vendorReport'>Vendor Report</a></TableCell>
           </TableRow>
           <TableRow>
           <TableCell style={{...tableStyle}}><a href='/customerReport'>Customer Report</a></TableCell>
           </TableRow>
        </TableBody>
        <TableFooter>
         
        </TableFooter>
      </Table>
    </TableContainer>
    </Container>
    </div>
  );
}

export default Reports